import { API_END_POINTS } from "utils/constants/APIEndPoints";
import { useMutationHook } from "./useMutationHook";
import axiosServices from "utils/axios";

const useFetchOrder = () => {
  const mutation = useMutationHook<any, Error, FormData>({
    mutationFn: (orderData: FormData) =>
      axiosServices
        .post(API_END_POINTS.getOrders?.url, orderData)
        .then((response) => response.data),
    queryKey: ["orders"],
  });

  const { mutateAsync, data, isLoading, isError, error, isSuccess, isIdle } =
    mutation;

  return {
    orders: mutateAsync,
    data,
    isLoading,
    isError,
    isSuccess,
    isIdle,
    error,
  };
};

export default useFetchOrder;
